import React from "react";
import { ElementsConsumer, CardElement } from "@stripe/react-stripe-js";
import ReactToolTip from 'react-tooltip';
import $ from 'jquery';
import Validate from '../common/validate';
import Axios from 'axios';
import { API_HOST, axiosRequest } from './../../constants/server.constant';
import ReCAPTCHA from "react-google-recaptcha";
import ReactTooltip from 'react-tooltip';
import CommonMessage from './../common/commonMessage';
import SessionService from '../../services/session.service';
import { loadStripe } from "@stripe/stripe-js";
import CardSectionSignUp from "./../signup/Cardsectionsignup";
import { Redirect } from "react-router";
import { userService } from './../../services/user.service';
import { removeCookieValueByName, getCookieValueByName, locationCount } from "../../utility/utility";
import { loginService } from "../../services/login.service";


class BareMetalCheckout extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            signupForm: {
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                companyName: '',
                countryCode: '+1',
                phoneNumber: '',
                billingAddress: '',
                zipCode: '',
                cardDetails: {
                    cardNumber: '',
                    expiryMonth: '',
                    expiryYear: '',
                    cvc: '',
                },
                isAgreed: false,
            },
            userid: "",
            authToken: "",
            hidePwd: true,
            isPwdShown: false,
            errors: {},
            loading: true,
            pwdstrength: "",
            firstNameEmpty: false,
            lastNameEmpty: false,
            emailEmpty: false,
            userNameEmpty: false,
            passwordEmpty: false,
            phoneNumberEmpty: false,
            billingAddressEmpty: false,
            zipCodeEmpty: false,
            checkboxstatus: false,
            userNameExists: false,
            isAction: false,
            stripePromise: loadStripe("pk_test_51I71o3KD8YUugTD1p18N7Kpq3RbEB05nTMGXkDTSQQYDMLcta9gO1rHGjIchv2qEF43QX0XnxC3mKZ01SgoJubO100F6VmFPbB"),
            stripeObj: {},
            isCardError: true,
            redirectFirstName: "",
            redirectEmail: "",
            firstNameRegex: false,
            lastNameRegex: false,
            emailRegex: false,
            userNameRegex: false,
            passwordRegex: false,
            phoneNumberRegex: false,
            zipCodeRegex: false,
            isPhoneVerifyPopup: false,
            otp: "",
            otpempty: false,
            otpErr: false,
            discountId: "",
            redirectError: false,
            promoDis: "",
            invalidDomain: false,
            showLoader: false,
            isMsgShow: false,
            showVerifyLoader: false,
            redirect: ``,
            isSwitch: false
        };

        this.formChangeHandler = this.formChangeHandler.bind(this);
        this.handlesubmit = this.handlesubmit.bind(this);
        this.validate = this.validate.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.recaptchaRef = React.createRef();
        this.firstNameInput = React.createRef();
        this.lastNameInput = React.createRef();
        this.emailInput = React.createRef();
        this.userNameInput = React.createRef();
        this.passwordInput = React.createRef();
        this.countryCodeInput = React.createRef();
        this.phoneNumberInput = React.createRef();
        this.billingAddressInput = React.createRef();
        this.zipCodeInput = React.createRef();
        this.inputFocus = this.inputFocus.bind(this);
        this.handleStripeSubmit = this.handleStripeSubmit.bind(this);
        this.verifyOtp = this.verifyOtp.bind(this);
        this.sendOtp = this.sendOtp.bind(this);
        this.otpInput = React.createRef();
        this.handleOTPKeyUp = this.keyUpHandler.bind(this, 'otpInput');
        this.handleOtp = this.handleOtp.bind(this);
        this.escfunction = this.escfunction.bind(this);

    }
    escfunction(event) {
        if(event.keyCode === 27) {
            this.setState({
                isPhoneVerifyPopup: false,
                showVerifyLoader: false
            });
            $("body").removeClass("no_scroll");

        }
    }

    handleOtp = (event) => {
        this.setState({
            otpErr: false,
            otpempty: false,
            otpVerification: false
        });
        let name = event.target.name;
        let val = event.target.value;
        this.setState({
            [name]: val
        });
    };
    keyUpHandler(refName, e) {
        if(refName == "otpInput") {
            if(e.keyCode == 13) {
                this.verifyOtp();
            }
            if(this.state.otp.length < 6) {
                $('#verify_btn').addClass("disabled");
            } else {
                $('#verify_btn').removeClass("disabled");
            }
        }
    }
    openPhoneVerifyPopup = () => {
        this.setState({
            showLoader: false,
            otp: "",
            isPhoneVerifyPopup: true,
            otpVerification: false,
            otpErr: false,
            otpempty: false,

        }, () => {
            this.toggleVerifyButton();
        });
        $('body').addClass("no_scroll");
        $('#otp').removeAttr("disabled");
        $('#otp').removeClass("disabled");
        setTimeout(() => {
            this.otpInput.current.focus();
        }, 100);

    };
    toggleVerifyButton() {
        $('#resend_msg').hide();
        if(this.state.otp.length < 6) {
            $('#verify_btn').attr("disabled", "disabled");
            $('#verify_btn').addClass("disabled");
        } else {
            $('#verify_btn').removeAttr("disabled");
            $('#verify_btn').removeClass("disabled");
        }
    }


    closePhoneVerifyPopup = () => {
        this.setState({
            isPhoneVerifyPopup: false,
            showLoader: false
        });
        $('body').removeClass("no_scroll");

    };
    startTimer() {
        //var mindisp = 0;
        //var secdis = 0;
        var countdown = 5 * 60 * 1000;
        //var timerId ;
        //clearInterval(timerId);
        this.timerId = setInterval(() => {
            countdown -= 1000;
            var min = Math.floor(countdown / (60 * 1000));
            //var sec = Math.floor(countdown - (min * 60 * 1000));  // wrong
            var sec = Math.floor((countdown - (min * 60 * 1000)) / 1000);
            if(min == 0 && sec == 0) {
                clearInterval(this.timerId);
                $('#otp_timer').html('The verification code has expired. Click "Resend OTP" to receive new code.');
                this.setState({
                    otp: ""
                }, () => {
                    $('#otp').attr("disabled", "disabled");
                    this.toggleVerifyButton();
                });
            } else {
                this.mindisp = min;
                this.secdis = sec;
                if(min < 10)
                    this.mindisp = "0" + min;
                if(sec < 10)
                    this.secdis = "0" + sec;
                if(min == 0) {
                    $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Seconds");
                } else {
                    $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Minutes");
                }
            }

        }, 1000);

    }
    verifyOtp = () => {
        this.setState({
            otpempty: false,
            otpErr: false,
            otpVerification: true
        });
        if(this.state.otp.trim() == "") {
            this.setState({
                otpempty: true,
                otpVerification: false
            });
            this.otpInput.current.focus();
            return;
        }

        if(!Validate("otp", this.state.otp.trim()) || this.state.otp.trim().length < 6) {
            this.setState({
                otpErr: true,
                otpVerification: false
            });
            this.otpInput.current.focus();
            return;
        }

        this.setState({
            otpempty: false,
            otpErr: false
        });
        this.setState({
            otpempty: false,
            otpErr: false,
            captchaType: "create"
        }, () => this.recaptchaRef.current.execute());
    };

    checkDomain = (event) => {
        let email = this.state.signupForm.email;
        this.setState({
            showLoader: true
        });
        email = email.split("@").pop();
        Axios.get(API_HOST + "/user/checkdomain?captcha=" + event + "&email=" + email, axiosRequest)
            .then(resp => {
                resp = resp.data;
                if(resp.body.error) {
                    if(resp.body.message === "TOO_MANY_CALLS") {
                        this.setState({
                            showLoader: false,
                            invalidDomain: false,
                            message: "Too many requests from this IP address. Try again after sometime",
                            msgType: "error"
                        });
                        this.emailInput.current.focus();
                        return;
                    }
                    this.setState({
                        showLoader: false,
                        invalidDomain: true
                    });
                    this.emailInput.current.focus();
                    return;

                }
                else {
                    this.setState({
                        smsType: "send",
                        captchaType: "otpsend"
                    }, () => this.recaptchaRef.current.execute());

                }
            }).catch(error => {
                this.setState({
                    showLoader: false
                });
            });
    };
    reSendOtp = (type, event) => {
        this.setState({
            smsType: "resend",
            captchaType: "otpsend"
        }, () => this.recaptchaRef.current.execute());
    };
    sendOtp = (event) => {
        let type = this.state.smsType;
        if(type == "send") {
            this.setState({
                showLoader: true,
            });
        }
        var email = this.state.signupForm.email;
        var phoneNumber = this.state.signupForm.phoneNumber;
        var cLabel = $("#countryCode option:selected").text();
        var c = cLabel.split('+');
        var cCode = '+' + c[1];
        this.setState({
            signupForm: {
                companyName: this.state.signupForm.companyName,
                countryCode: this.state.signupForm.countryCode,
                email: this.state.signupForm.email,
                firstName: this.state.signupForm.firstName,
                lastName: this.state.signupForm.lastName,
                password: this.state.signupForm.password,
                phoneNumber: this.state.signupForm.phoneNumber,
                billingAddress: this.state.signupForm.billingAddress,
                zipCode: this.state.signupForm.zipCode,
                isAgreed: this.state.signupForm.isAgreed
            }
        }, () => {

            var otpDetails = {
                "email": email,
                "countryCode": cCode.trim(),
                "phone": phoneNumber
            };
            if(type == "resend") {
                $("#resend_btn").attr('disabled', 'disabled');
                $('#resend_btn').addClass("disabled");
                setTimeout(() => {
                    $("#resend_btn").removeAttr('disabled');
                    $('#resend_btn').removeClass("disabled");
                }, 10000);
            }

            Axios.post(API_HOST + `/resource/send/profile/otp?captcha=` + event, otpDetails, axiosRequest)
                .then(resp => {
                    let res = resp.data;
                    if(res === undefined) {
                        if(type == "send") {
                            this.setState({
                                showLoader: false,
                                isPhoneVerifyPopup: false,
                                message: "Phone number could not be verified. Enter a valid phone number and try again.",
                                msgType: 'error'
                            });
                            if(this.recaptchaRef.current)
                                this.recaptchaRef.current.reset();
                            this.phoneNumberInput.current.focus();
                            $('body').removeClass("no_scroll");
                        } else {
                            //if error occured during resend
                        }
                    } else {
                        if(res === "TOO_MANY_CALLS") {
                            this.setState({
                                showLoader: false,
                                message: "Too many requests from this IP address. Try again after sometime",
                                isPhoneVerifyPopup: false,
                                msgType: 'error'
                            });
                            $('body').removeClass("no_scroll");
                            return;
                        }
                        clearInterval(this.timerId);
                        this.startTimer();
                        if(type == "resend") {
                            $('#verify_otp_msg').hide();
                            $('#otp').removeAttr('disabled');
                            $('#resend_msg').show();
                            setTimeout(() => {
                                $('#resend_msg').hide();
                            }, 3000);
                        } else {
                            this.openPhoneVerifyPopup();
                        }
                        if(this.recaptchaRef.current)
                            this.recaptchaRef.current.reset();
                        this.otpInput.current.focus();
                    }
                }).catch(error => {
                    this.setState({
                        showLoader: false,
                        message: "Phone number could not be verified. Enter a valid phone number and try again.",
                        msgType: 'error'
                    });
                    if(this.recaptchaRef.current)
                        this.recaptchaRef.current.reset();
                    this.phoneNumberInput.current.focus();
                    return false;
                });
            /*ResourceService.sendOtpOnSign(otpDetails).then(res =>{
              
                //console.log(res)
                this.setState({
                  showLoader:false
                })
                if(res === undefined) {
                    if(type == "send") {
                        this.setState({
                          message : "Phone number could not be verified. Enter a valid phone number and try again.",
                          msgType: 'error'
                        })    
                        this.phoneNUmberFocus.current.focus();
                    } else {
                        //if error occured during resend
                    }
                } else {
                    clearInterval(this.timerId)
                    this.startTimer();
                    if(type == "resend") {
                        $('#verify_otp_msg').hide(); 
                        $('#otp').removeAttr('disabled');
                        $('#resend_msg').show();
                        setTimeout(() => {
                            $('#resend_msg').hide();
                        }, 3000);
                    } else {
                        this.openPhoneVerifyPopup();
                    }
                    this.otpInput.current.focus()
                }
            })*/
        });

    };

    handleStripeSubmit = async event => {
        const { stripe, elements } = this.props;
        if(!stripe || !elements) {
            return;
        }

        const card = elements.getElement(CardElement);

        const result = await stripe.createToken(card, { address_line1: this.state.signupForm.billingAddress, address_zip: this.state.signupForm.zipCode });
        if(result.error) {
            //console.log(result.error.message);
            // this.setState({
            //   message : result.error.message,
            // })  
            var errspan = document.getElementById("ccDetailsErr");
            errspan.innerText = result.error.message;
            errspan.style.display = "block";
            setTimeout(() => {
                errspan.innerText = "";
                errspan.style.display = "block";
            }, 5000);

            return;
        } else {
            this.setState({
                stripeObj: result.token,
                isCardError: false
            });
            if(this.state.signupForm.billingAddress.trim().length <= 0) {
                this.setState({
                    billingAddressEmpty: true
                });
                this.billingAddressInput.current.focus();
                return;
            }
            else if(this.state.signupForm.zipCode.trim().length <= 0) {
                this.setState({
                    zipCodeEmpty: true
                });
                this.zipCodeInput.current.focus();
                return;
            }
            else if(Validate("zipCode", this.state.signupForm.zipCode.trim())) {
                this.setState({
                    zipCodeRegex: true
                });
                this.zipCodeInput.current.focus();
                return false;
            }
            else if(!(this.state.signupForm.isAgreed)) {
                document.getElementById("terms_wrap").scrollIntoView(true);
                setTimeout(() => {
                    this.setState({
                        checkboxstatus: !this.state.checkboxstatus
                    });

                }, 10000);
                this.setState({
                    checkboxstatus: !this.state.checkboxstatus
                });
            }
            else {
                let email = this.state.signupForm.email;
                this.setState({
                    captchaType: "domain"
                }, () => this.recaptchaRef.current.execute());

            }

        }
        //console.log(result)
        //return result;
    };

    inputFocus = (event, param) => {
        if(param == "lastfield") {
            if(this.state.signupForm.phoneNumber.trim().length <= 0) {
                this.setState({
                    phoneNumberEmpty: true
                });
            }
            else if(this.state.signupForm.phoneNumber.trim().length > 0) {
                this.setState({
                    phoneNumberEmpty: false
                });
                const phoneNumRegex = new RegExp("^[xX0-9-+()]+$");
                if(!phoneNumRegex.test(this.state.signupForm.phoneNumber) || this.state.signupForm.phoneNumber.trim().length > 20) {
                    this.setState({
                        phoneNumberRegex: true
                    });
                } else {
                    this.setState({
                        phoneNumberRegex: false
                    });
                }

            }
        }
        else if(param === "lastname") {
            if(this.state.signupForm.firstName.trim().length <= 0) {
                this.setState({
                    firstNameEmpty: true
                });
            }
            if(this.state.signupForm.firstName.trim().length > 0) {

                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {

                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
        }
        else if(param === "email") {
            if(this.state.signupForm.firstName.trim().length <= 0) {
                this.setState({
                    firstNameEmpty: true
                }
                );
            }
            if(this.state.signupForm.lastName.trim().length <= 0) {
                this.setState({
                    lastNameEmpty: true
                });
            }
            if(this.state.signupForm.firstName.trim().length > 0) {

                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {
                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.lastName.trim().length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
                if(!Validate("lastName", this.state.signupForm.lastName)) {
                    this.setState({
                        lastNameRegex: true
                    });
                }
                else {
                    this.setState({
                        lastNameRegex: false
                    });
                }
            }
        }
        else if(param === "password") {
            if(this.state.signupForm.firstName.trim().length <= 0) {
                this.setState({
                    firstNameEmpty: true
                });
            }
            if(this.state.signupForm.lastName.trim().length <= 0) {
                this.setState({
                    lastNameEmpty: true
                });
            }
            if(this.state.signupForm.email.length <= 0) {
                this.setState({
                    emailEmpty: true
                });
            }

            if(this.state.signupForm.firstName.trim().length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {
                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.lastName.trim().length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
                if(!Validate("lastName", this.state.signupForm.lastName)) {
                    this.setState({
                        lastNameRegex: true
                    });
                }
                else {
                    this.setState({
                        lastNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.email.length > 0) {
                this.setState({
                    emailEmpty: false,
                    invalidDomain: false
                });
                if(!Validate("email", this.state.signupForm.email)) {
                    this.setState({
                        emailRegex: true,
                        invalidDomain: false
                    });
                }
                else {
                    this.setState({
                        emailRegex: false,
                        invalidDomain: false
                    });
                }
            }

        }
        else if(param === "company") {
            if(this.state.signupForm.firstName.length <= 0) {

                this.setState({
                    firstNameEmpty: true
                });
            }
            if(this.state.signupForm.lastName.length <= 0) {

                this.setState({
                    lastNameEmpty: true
                });
            }
            if(this.state.signupForm.email.length <= 0) {

                this.setState({
                    emailEmpty: true
                });
            }

            if(this.state.signupForm.password.length <= 0) {

                this.setState({
                    passwordEmpty: true
                });
            }
            if(this.state.signupForm.firstName.length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {
                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.lastName.length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
                if(!Validate("lastName", this.state.signupForm.lastName)) {
                    this.setState({
                        lastNameRegex: true
                    });
                }
                else {
                    this.setState({
                        lastNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.email.length > 0) {
                this.setState({
                    emailEmpty: false
                });
                if(!Validate("email", this.state.signupForm.email)) {
                    this.setState({
                        emailRegex: true,
                        invalidDomain: false
                    });
                }
                else {
                    this.setState({
                        emailRegex: false,
                        invalidDomain: false
                    });
                }
            }

            if(this.state.signupForm.password.length > 0) {
                this.setState({
                    passwordEmpty: false
                });

                if(!Validate("password", this.state.signupForm.password)) {
                    this.setState({
                        passwordRegex: true
                    });
                }
                else {
                    this.setState({
                        passwordRegex: false
                    });
                }
            }

        }
        else if(param === "phone") {
            if(this.state.signupForm.firstName.trim().length <= 0) {

                this.setState({
                    firstNameEmpty: true
                });
            }
            if(this.state.signupForm.lastName.trim().length <= 0) {

                this.setState({
                    lastNameEmpty: true
                });
            }
            if(this.state.signupForm.email.length <= 0) {

                this.setState({
                    emailEmpty: true
                });
            }

            if(this.state.signupForm.password.length <= 0) {

                this.setState({
                    passwordEmpty: true
                });
            }
            if(this.state.signupForm.firstName.trim().length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
            }
            if(this.state.signupForm.firstName.trim().length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {
                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.lastName.trim().length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
                if(!Validate("lastName", this.state.signupForm.lastName)) {
                    this.setState({
                        lastNameRegex: true
                    });
                }
                else {
                    this.setState({
                        lastNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.email.length > 0) {
                this.setState({
                    emailEmpty: false
                });
                if(!Validate("email", this.state.signupForm.email)) {
                    this.setState({
                        emailRegex: true,
                        invalidDomain: false
                    });
                }
                else {
                    this.setState({
                        emailRegex: false,
                        invalidDomain: false
                    });
                }
            }

            if(this.state.signupForm.password.length > 0) {
                this.setState({
                    passwordEmpty: false
                });
                if(!Validate("password", this.state.signupForm.password)) {
                    this.setState({
                        passwordRegex: true
                    });
                }
                else {
                    this.setState({
                        passwordRegex: false
                    });
                }
            }

        }
        if(param === "card") {
            if(this.state.signupForm.phoneNumber <= 0) {
                this.setState({
                    phoneNumberEmpty: true
                });
            }
            else if(this.state.signupForm.phoneNumber > 0) {
                this.setState({
                    phoneNumberEmpty: false
                });

            }
        }
        if(param === "billing") {
            if(this.state.signupForm.firstName.trim().length <= 0) {

                this.setState({
                    firstNameEmpty: true
                });
            }
            if(this.state.signupForm.lastName.trim().length <= 0) {

                this.setState({
                    lastNameEmpty: true
                });
            }
            if(this.state.signupForm.email.length <= 0) {

                this.setState({
                    emailEmpty: true
                });
            }

            if(this.state.signupForm.password.length <= 0) {

                this.setState({
                    passwordEmpty: true
                });
            }
            if(this.state.signupForm.phoneNumber.length <= 0) {

                this.setState({
                    phoneNumberEmpty: true
                });
            }
            if(this.state.signupForm.firstName.trim().length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
            }
            if(this.state.signupForm.firstName.trim().length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {
                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.lastName.trim().length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
                if(!Validate("lastName", this.state.signupForm.lastName)) {
                    this.setState({
                        lastNameRegex: true
                    });
                }
                else {
                    this.setState({
                        lastNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.email.length > 0) {
                this.setState({
                    emailEmpty: false
                });
                if(!Validate("email", this.state.signupForm.email)) {
                    this.setState({
                        emailRegex: true,
                        invalidDomain: false
                    });
                }
                else {
                    this.setState({
                        emailRegex: false,
                        invalidDomain: false
                    });
                }
            }

            if(this.state.signupForm.password.length > 0) {
                this.setState({
                    passwordEmpty: false
                });
                if(!Validate("password", this.state.signupForm.password)) {
                    this.setState({
                        passwordRegex: true
                    });
                }
                else {
                    this.setState({
                        passwordRegex: false
                    });
                }
            }
            if(this.state.signupForm.phoneNumber.length > 0) {

                this.setState({
                    phoneNumberEmpty: false
                });
            }
        }
        if(param === "zipcode") {
            if(this.state.signupForm.firstName.trim().length <= 0) {

                this.setState({
                    firstNameEmpty: true
                });
            }
            if(this.state.signupForm.lastName.trim().length <= 0) {

                this.setState({
                    lastNameEmpty: true
                });
            }
            if(this.state.signupForm.email.length <= 0) {

                this.setState({
                    emailEmpty: true
                });
            }

            if(this.state.signupForm.password.length <= 0) {

                this.setState({
                    passwordEmpty: true
                });
            }
            if(this.state.signupForm.phoneNumber.length <= 0) {

                this.setState({
                    phoneNumberEmpty: true
                });
            }
            if(this.state.signupForm.billingAddress.length <= 0) {

                this.setState({
                    billingAddressEmpty: true
                });
            }
            if(this.state.signupForm.firstName.trim().length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
            }
            if(this.state.signupForm.firstName.trim().length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {
                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.lastName.trim().length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
                if(!Validate("lastName", this.state.signupForm.lastName)) {
                    this.setState({
                        lastNameRegex: true
                    });
                }
                else {
                    this.setState({
                        lastNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.email.length > 0) {
                this.setState({
                    emailEmpty: false
                });
                if(!Validate("email", this.state.signupForm.email)) {
                    this.setState({
                        emailRegex: true,
                        invalidDomain: false
                    });
                }
                else {
                    this.setState({
                        emailRegex: false,
                        invalidDomain: false
                    });
                }
            }

            if(this.state.signupForm.password.length > 0) {
                this.setState({
                    passwordEmpty: false
                });
                if(!Validate("password", this.state.signupForm.password)) {
                    this.setState({
                        passwordRegex: true
                    });
                }
                else {
                    this.setState({
                        passwordRegex: false
                    });
                }
            }
            if(this.state.signupForm.phoneNumber.length > 0) {

                this.setState({
                    phoneNumberEmpty: false
                });
            }
            if(this.state.signupForm.billingAddress.length > 0) {

                this.setState({
                    billingAddressEmpty: false
                });
            }
        }
        if(param === "zipcodeblur") {
            if(this.state.signupForm.zipCode.length <= 0) {

                this.setState({
                    zipCodeEmpty: true
                });
            }
            if(this.state.signupForm.zipCode.length > 0) {

                this.setState({
                    zipCodeEmpty: false
                });
            }
        }

    };
    formChangeHandler = (event) => {

        let name = event.target.name;
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.state.signupForm[name] = val;
        if(name === "firstName") {
            if(val.length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    firstNameEmpty: true,
                    firstNameRegex: false
                });
            }
        }
        if(name === "lastName") {
            if(val.length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    lastNameEmpty: true,
                    lastNameRegex: false
                });
            }
        }
        if(name === "email") {
            if(val.length > 0) {
                this.setState({
                    emailEmpty: false,
                    userNameExists: false,
                    invalidDomain: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    emailEmpty: true,
                    emailRegex: false,
                    userNameExists: false,
                    invalidDomain: false
                });
            }
        }

        if(name === "password") {


            const passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-_+=(){}!@#\/\$%\^&\*:;'\"])(?=\\S+$)(?=.{8,})");
            if(val.length > 0) {
                if(passwordRegex.test(val)) {
                    this.setState({
                        pwdstrength: "strong"
                    });
                }
                else {
                    this.setState({
                        pwdstrength: "weak"
                    });
                }
                this.setState({
                    passwordEmpty: false
                });
                var upCasePatt = new RegExp("[A-Z]");
                if(upCasePatt.test(val)) {
                    $('#upperCaseLi').addClass("success");
                } else {
                    $('#upperCaseLi').removeClass("success");
                }
                var lowCasePatt = new RegExp("[a-z]");
                if(lowCasePatt.test(val)) {
                    $('#lowerCaseLi').addClass("success");
                } else {
                    $('#lowerCaseLi').removeClass("success");
                }
                var numericPatt = new RegExp("[0-9]");
                if(numericPatt.test(val)) {
                    $('#numericLi').addClass("success");
                } else {
                    $('#numericLi').removeClass("success");
                }
                var specCharPat = /[`!@#$%^&*()_+\-={};':"|,.<>\/?~]/;

                if(specCharPat.test(val)) {
                    $('#specCharLi').addClass("success");
                } else {
                    $('#specCharLi').removeClass("success");
                }

                if(val.length >= 8) {
                    $('#eightCharLi').addClass("success");
                } else {
                    $('#eightCharLi').removeClass("success");
                }
            }
            else if(val.length <= 0) {
                this.setState({
                    passwordEmpty: true,
                    pwdstrength: "",
                    passwordRegex: false
                });
                $('#upperCaseLi').removeClass("success");
                $('#specCharLi').removeClass("success");
                $('#eightCharLi').removeClass("success");
                $('#numericLi').removeClass("success");
                $('#lowerCaseLi').removeClass("success");
            }


        }
        if(name === "phoneNumber") {

            if(val.length > 0) {

                this.setState({
                    phoneNumberEmpty: false,
                    phoneNumberRegex: false
                });
                const numRegex = new RegExp("^[0-9]+$");
                if(numRegex.test(val)) {
                    if(val.length >= 7) {
                        $('#min_sev').addClass("success");
                    } else {
                        $('#min_sev').removeClass("success");
                    }

                    if(val.length > 0 && val.length <= 20) {
                        $('#max_twe').addClass("success");
                    } else {
                        $('#max_twe').removeClass("success");
                    }

                    const phoneNumRegex = new RegExp("^[xX0-9-+()]+$");
                    if(phoneNumRegex.test(val)) {
                        $('#no_spe').addClass("success");
                    } else {
                        $('#no_spe').removeClass("success");
                    }
                }
                else {
                    $('#min_sev').removeClass("success");
                    $('#max_twe').removeClass("success");
                    $('#no_spe').removeClass("success");
                }

            }
            else if(val.length <= 0) {
                this.setState({
                    phoneNumberEmpty: true,
                    phoneNumberRegex: false
                });
                $('#min_sev').removeClass("success");
                $('#max_twe').removeClass("success");
                $('#no_spe').removeClass("success");
            }
        }
        if(val !== undefined && val !== '') {
            this.state.errors[name] = false;
        }

        if(name == "billingAddress") {
            if(val.length > 0) {
                this.setState({
                    billingAddressEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    billingAddressEmpty: true,

                });
            }
        }

        if(name == "zipCode") {

            if(val.length > 0) {
                this.setState({
                    zipCodeEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    zipCodeEmpty: true
                });
            }
        }

        this.setState({
            signupForm: this.state.signupForm,
            errors: this.state.errors
        });
    };

    handleToggle(event) {
        this.setState({
            hidePwd: !this.state.hidePwd,
            isPwdShown: !this.state.isPwdShown,
        });
    }

    handlesubmit(event) {
        event.preventDefault();
        if(this.validate()) {
            this.handleStripeSubmit();
        } else {
            return false;
        }


    }

    onRecaptchaChange = (event) => {
        if(this.state.captchaType == "domain") {
            this.checkDomain(event);
        }
        else if(this.state.captchaType == "otpsend") {
            this.sendOtp(event);
        }
        else if(this.state.captchaType == "login") {
            this.doAutoLogin(event);
        }
        else {
            this.createUser(event);
        }
    };

    doAutoLogin(event) {

        loginService.authenticate(event, JSON.stringify({ email: this.state.signupForm.email.trim(), password: this.state.signupForm.password })).then(authResp => {
            if(!authResp.data?.error) {
                userService.getUserData().then(response => {
                    this.setState({ redirect: authResp.data?.redirect });
                }).catch((error) => {
                    this.closePhoneVerifyPopup();
                    this.setState({
                        wrongcreds: true,
                        message: "Error While trying to connect",
                        showLoader: false,
                        msgType: 'error'
                    });
                    if(this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }

                });
            }
            else {
                this.closePhoneVerifyPopup();
                this.setState({
                    wrongcreds: true,
                    message: "Error while fetching Details, try again!",
                    showLoader: false,
                    msgType: 'error'
                });
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }

            }
        }).catch(err => {
            this.closePhoneVerifyPopup();
            this.setState({
                message: "Error while fetching Details, try again!",
                showLoader: false,
                msgType: 'error'
            });
            if(this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }

            return;
        });
    }

    createUser(event) {
        // this.handleStripeSubmit().then(result => {
        //     if (result.error) {
        //         console.log(result.error.message);
        //         this.setState({
        //             message : "Error while fetching Details, try again!",
        //             isAction:false
        //         })
        //     } else {
        //         console.log(result.token);

        //     }
        //    }).catch(err =>{
        //        console.log(err)
        //        this.setState({
        //             message : "Error while fetching Details, try again!",
        //             isAction:false
        //         })
        //    }) ;
        this.setState({
            showVerifyLoader: true
        });
        const data = {
            companyName: this.state.signupForm.companyName,
            countryCode: this.state.signupForm.countryCode,
            email: this.state.signupForm.email.trim(),
            firstName: this.state.signupForm.firstName.trim(),
            lastName: this.state.signupForm.lastName.trim(),
            password: this.state.signupForm.password,
            phone: this.state.signupForm.phoneNumber.trim(),
            otp: this.state.otp,
            discountId: this.state.discountId

        };
        const history = this.props.history;
        Axios.post(API_HOST + '/user/create/promosignup?captcha=' + event + '&discountId=' + data.discountId + '&type=baremetal',
            JSON.stringify({
                companyName: data.companyName,
                countryCode: data.countryCode,
                email: data.email,
                firstName: data.firstName,
                lastName: data.lastName,
                password: data.password,
                phone: data.phone,
                status: 'Y',
                otp: data.otp,
                stripeObj: JSON.stringify({ "token": this.state.stripeObj, "billingAddress": this.state.signupForm.billingAddress, "zipcode": this.state.signupForm.zipCode }),
                partnerToken: this.state.computeTagCkVal
            })
            , axiosRequest).then(
                (response) => {

                    this.setState({
                        showVerifyLoader: false
                    });
                    if(response.data.error) {
                        if(response.data.message === "INVALID_CARD" || response.data.message === "INVALID_CUSTOMER") {
                            this.setState({
                                message: "Sign up could not be completed as your credit card could not be processed. Try again with a valid credit card.",
                                showLoader: false,
                                msgType: 'error'
                            });
                            this.closePhoneVerifyPopup();
                            return;
                        }
                        else if(response.data.message === "INVALID_DOMAIN") {
                            this.setState({
                                invalidDomain: true,
                                showLoader: false
                            });
                            this.emailInput.current.focus();
                            if(this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }
                            this.closePhoneVerifyPopup();
                            return;
                        }
                        else if(response.data.message === "TIME_OUT") {
                            this.setState({
                                invalidDomain: false,
                                showLoader: false,
                                message: "There was some problem during email verification. Please try again.",
                                msgType: "error"
                            });
                            this.emailInput.current.focus();
                            if(this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }
                            this.closePhoneVerifyPopup();
                            return;
                        }
                        else if(response.data.message === "INVALID_OTP") {
                            $('#verify_otp_msg').show();
                            setTimeout(() => {
                                $('#verify_otp_msg').hide();
                            }, 5000);
                            this.setState({
                                otp: "",
                                otpVerification: false,
                                invalidDomain: false,
                                userNameExists: false
                            }, () => {
                                this.toggleVerifyButton();
                            });
                            this.otpInput.current.focus();
                            return;
                        }
                        else if(response.data.message === "EMAIL_EXISTS") {
                            this.setState({
                                userNameExists: true,
                                showLoader: false,
                                emailRegex: false
                            });
                            this.emailInput.current.focus();
                            if(this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }
                            this.closePhoneVerifyPopup();
                            return;
                        }
                        else if(response.data.message === "VALIDATION_ERROR") {
                            this.setState({
                                userNameExists: false,
                                showLoader: false,
                                emailRegex: true
                            });
                            this.emailInput.current.focus();
                            if(this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }
                            this.closePhoneVerifyPopup();
                            return;
                        }

                    }
                    this.setState({ showLoader: true });
                    if(response.status === 201) {
                        try {
                            removeCookieValueByName('compute_tag');
                        } catch(err) {
                            console.log(err);
                        }
                        this.setState({
                            isPhoneVerifyPopup: false
                        });
                        this.setState({
                            captchaType: "login"
                        }, () => this.recaptchaRef.current.execute());
                    }
                    else {
                        this.closePhoneVerifyPopup();
                        this.setState({
                            message: "Error while fetching Details, try again!",
                            isAction: false,
                            msgType: 'error'
                        });
                        if(this.recaptchaRef.current) {
                            this.recaptchaRef.current.reset();
                        }

                    }
                }
            ).catch(error => {

                this.closePhoneVerifyPopup();
                this.setState({
                    message: "Sign up could not be completed as your credit card could not be processed. Try again with a valid credit card.",
                    isAction: false,
                    msgType: 'error'
                });
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
            });
    }

    validate() {
        if(this.state.signupForm.firstName.trim().length <= 0) {
            this.setState({
                firstNameEmpty: true
            });
            this.firstNameInput.current.focus();
            return false;
        }
        else if(this.state.signupForm.lastName.trim().length <= 0) {
            this.setState({
                lastNameEmpty: true
            });
            this.lastNameInput.current.focus();
            return false;
        }
        else if(this.state.signupForm.email.length <= 0) {
            this.setState({
                emailEmpty: true
            });
            this.emailInput.current.focus();
            return false;
        }

        else if(this.state.signupForm.password.length <= 0) {
            this.setState({
                passwordEmpty: true,

            });
            this.passwordInput.current.focus();
            return false;
        }
        else if(this.state.signupForm.phoneNumber.trim().length <= 0) {
            this.setState({
                phoneNumberEmpty: true
            });
            this.phoneNumberInput.current.focus();
            return false;
        }

        else {

            if(!Validate("firstName", this.state.signupForm.firstName)) {
                this.setState({
                    firstNameRegex: true
                });
                this.firstNameInput.current.focus();
                return false;

            }
            else if(!Validate("lastName", this.state.signupForm.lastName)) {
                this.setState({
                    lastNameRegex: true
                });
                this.lastNameInput.current.focus();
                return false;

            }
            else if(!Validate("email", this.state.signupForm.email)) {
                this.setState({
                    emailRegex: true,
                    invalidDomain: false
                });
                this.emailInput.current.focus();
                return false;
            }

            else if(!Validate("password", this.state.signupForm.password)) {
                this.setState({
                    passwordRegex: true
                });
                this.passwordInput.current.focus();
                return false;
            } else if(!Validate("phoneNumber", this.state.signupForm.phoneNumber)) {
                this.setState({
                    phoneNumberRegex: true
                });
                this.phoneNumberInput.current.focus();
                return false;
            }
            else {
                return true;
            }

        }


    }

    componentDidMount() {
        window.location.href = "https://www.idrive.com/idrive/signup";
        var compute_tag_Val = getCookieValueByName('compute_tag');
        if(compute_tag_Val) {
            let firstChar = compute_tag_Val.charAt(0);
            if(firstChar === 'P') this.setState({ computeTagCkVal: compute_tag_Val });
        }

        this.setState({
            showLoader: true
        });
        document.addEventListener("keyup", this.escfunction, false);
        window.scrollTo(0, 0);
        let path = window.location.pathname.split("/");
        let promo = path[path.length - 1];
        if(promo.includes("switch")) {
            this.setState({
                isSwitch: true
            });

        }
        let history = this.props.history;

        Axios.get(API_HOST + "/user/getCompanyPromo?promo=" + promo + '&type=baremetal', axiosRequest).then(resp => {

            let res = resp.data;
            if(res.body.error) {
                this.setState({
                    redirectError: true
                });
            }
            else {
                this.setState({
                    promoDis: res.body.discount,
                    discountId: promo,
                    showLoader: false
                });
            }
            this.checkEntry();
        }).catch(error => {
            this.setState({
                redirectError: true
            });
        });
        document.title = "IDrive® Compute | Sign-up page";
        loginService.clearLocalSession();
    }
    checkEntry = () => {
        this.setState({
            showLoader: true
        });
        userService.checkEntry().then(resp => {
            if(resp === false) {
                this.setState({
                    message: "Error while trying to connect",
                    showLoader: false
                });
                return;
            }
            if(resp.data.body === "HIDE_MESSAGE") {
                this.setState({
                    isMsgShow: false,
                    showLoader: false
                });
            }
            if(resp.data.body === "SHOW_MESSAGE") {
                this.setState({
                    isMsgShow: true,
                    showLoader: false
                });
            }

        }).catch(err => {
            this.setState({
                message: "Error while trying to connect",
                showLoader: false
            });
            return;
        });
    };


    render() {
        if(this.state.redirectError) {
            return <Redirect to="/error" />;
        } else if(SessionService.getCookie("isLoggedIn") && this.state.redirect !== ``) {
            return <Redirect to={ this.state.redirect } replace={ true }></Redirect>;
        }
        return (
            <body className={ this.state.isSwitch ? "switch_page bmetalTechradar" : "promo_page bmetalTechradar" }>
                <div className="full_page_loader" style={ { display: this.state.showLoader ? 'block' : 'none' } }>
                    <div className="loader_icon"></div>
                </div>
                <header id="main_header" className="header_cont">
                    <div className="container">
                        <h1 className="logo_h1"><a href="www.idrivecompute.com/index.html" className="logo_cont"></a></h1>
                    </div>
                </header>
                <header className="mobile_header"></header>
                <main className="static">
                    <div className={ this.state.isSwitch ? "switch_container" : "promo_container" }>
                        <div className={ this.state.isSwitch ? "switch_bg" : "promo_bg promobg_new" }>
                            <div className="container">
                                <a href="https://www.idrivecompute.com" className="logo">
                                    <img src="https://www.idrivecompute.com/promo/include/images/computelogo_new.svg" alt="Logo"></img>
                                </a>
                                <div class="switch_cont_blk" style={ { display: this.state.isSwitch ? "block" : "none" } }>
                                    <div class="switch_cont_lft">
                                        <h1>Switch<small>to Virtual Private Servers you can trust with services at over { locationCount } locations</small></h1>
                                        <div class="switch_info">
                                            <div class="switch_infoLft">
                                                <h2><span>SAVE</span><sup>*</sup><b>90%</b></h2>
                                                <small>on yearly plans</small> </div>
                                            <div class="switch_infoRgt vps_remove">
                                                <span class="pricewhen">Starts at</span> <span class="baseprice"><i>$2220</i> /year</span> <span class="getPrice"> <strong>${ 2220 - (2220 * this.state.promoDis / 100) }</strong>
                                                    <p><span> for the first year</span></p>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="switch_cont_rgt">
                                        <img src="https://www.idrivecompute.com/switch/include/images/map.png" /> </div>
                                </div>
                                <div className="promo_cont_blk" style={ { display: this.state.isSwitch ? "none" : "block" } }>
                                    <div className="promo_cont_lft">
                                        <h1>Bare Metal Servers<small>Convenience of cloud and direct hardware access;<span>available at { locationCount } locations and growing</span></small></h1>
                                        <div className="promo_info">
                                            <div className="promo_infoLft">
                                                <h2><span>SAVE</span><sup>*</sup><b>{ this.state.promoDis }%</b></h2>
                                                <small>on yearly plans</small>
                                            </div>
                                            <div className="promo_infoRgt vps_remove">
                                                <span class="pricewhen">Starts at </span>
                                                <span class="baseprice"><i>$2220</i> /year</span>
                                                <span class="getPrice">
                                                    <strong>${ 2220 - (2220 * this.state.promoDis / 100) } </strong>
                                                    <p><span> for the first year</span></p>
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="promo_cont_rgt">
                                        <img src="https://www.idrivecompute.com/promo/include/images/map_new.svg"></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className={ this.state.isSwitch ? "switch_content_wrap clearfix" : "promo_content_wrap clearfix" }>
                                <section className={ this.state.isSwitch ? "switch_lhs" : "promo_lhs" }>
                                    <div className="banner_sec">
                                        <h1>Dedicated bare-metal computing combined with the convenience of cloud</h1>
                                        <p className="title_txt" style={ { display: "none" } }>Quickly create virtual machines with desired configurations, manage and access them from any location.</p>
                                    </div>
                                    <div className="info_pointers">
                                        <ul>

                                            <li>
                                                <figure class="icon_img customCtrl"></figure>
                                                <div class="info_content_wrap">
                                                    <h3>
                                                        <p>Customize and control hardware</p>
                                                    </h3>
                                                    <p>The IDrive Compute bare metal servers are set up exclusively for you to facilitate their direct access and management.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <figure class="icon_img deployHardware"></figure>
                                                <div class="info_content_wrap">
                                                    <h3>
                                                        <p>Deploy hardware closer to end users</p>
                                                    </h3>
                                                    <p>The bare-metal servers can be placed in a region near the end users for optimum performance and low latency.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <figure class="icon_img intenseWorkload"></figure>
                                                <div class="info_content_wrap">
                                                    <h3>
                                                        <p>Run resource-intensive workloads</p>
                                                    </h3>
                                                    <p>With single-tenant dedicated hardware, run and execute resource-intensive operations.</p>
                                                </div>
                                                <div class="info_content_wrap_ul">
                                                    <ul class="rhs_lists">
                                                        <li>Single tenancy</li>
                                                        <li>Non-virtualized hardware</li>
                                                        <li>Dedicated server</li>
                                                        <li>Centralized management</li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                        <p className="offer_note">
                                            <span className="offer_note_star">*</span>
                                            <span className="offer_note_info">Note</span>:
                                        </p>
                                        <ul className="note_list">
                                            <li className="offer_note_para">- The { this.state.promoDis }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.</li>
                                            <li class="offer_note_para" style={ { display: this.state.isMsgShow ? "" : "none" } } >- Email addresses with a valid business domain can be used for creating the yearly account.</li>

                                        </ul>
                                    </div>
                                </section>
                                <section className={ this.state.isSwitch ? "switch_rhs" : "promo_rhs" }>
                                    <form onSubmit={ this.handlesubmit }>
                                        <div className="inp_primary_box">
                                            <div className="inp_row clearfix">
                                                <div className="inp_col_lhs">
                                                    <label>First Name</label>
                                                    <input type="text" autoFocus maxLength="20" ref={ this.firstNameInput } id="firstName" name="firstName" value={ this.state.signupForm.firstName } onChange={ this.formChangeHandler } className="txt_box" />
                                                    <span className="err_msg" id="firstNameErr" style={ { display: this.state.firstNameEmpty ? 'inline-block' : 'none' } } >First name cannot be blank</span>
                                                    <span className="err_msg" style={ { display: (this.state.errors["firstName"] !== undefined && this.state.errors["firstName"]) ? 'inline-block' : 'none' } } >First name can contain a-z, A-Z and space </span>
                                                    <span className="err_msg" style={ { display: this.state.firstNameRegex ? 'inline-block' : 'none' } } >First name can contain a-z, A-Z and space </span>  </div>
                                                <div className="inp_col_rhs">
                                                    <label>Last Name</label>
                                                    <input type="text" maxLength="20" id="lastName" ref={ this.lastNameInput } name="lastName" value={ this.state.signupForm.lastName } onChange={ this.formChangeHandler } onFocus={ (e) => this.inputFocus(e, "lastname") } onClick={ (e) => this.inputFocus(e, "lastname") } className="txt_box" />
                                                    <span className="err_msg" id="lastNameErr" style={ { display: this.state.lastNameEmpty ? 'inline-block' : 'none' } } >Last name cannot be blank</span>
                                                    <span className="err_msg" style={ { display: (this.state.errors["lastName"] !== undefined && this.state.errors["lastName"]) ? 'inline-block' : 'none' } }>Last name can contain a-z, A-Z and space</span>
                                                    <span className="err_msg" style={ { display: this.state.lastNameRegex ? 'inline-block' : 'none' } } >Last name can contain a-z, A-Z and space </span> </div>
                                            </div>
                                            <div className="inp_row clearfix">
                                                <label>Email</label>
                                                <input type="text" placeholder="name@company.com" ref={ this.emailInput } id="email" name="email" value={ this.state.signupForm.email } onChange={ this.formChangeHandler } onFocus={ (e) => this.inputFocus(e, "email") } onClick={ (e) => this.inputFocus(e, "email") } className="txt_box" />
                                                <span className="err_msg" id="emailErr" style={ { display: this.state.emailEmpty ? 'inline-block' : 'none' } } >Email address is invalid</span>
                                                <span className="err_msg" style={ { display: (this.state.errors["email"] !== undefined && this.state.errors["email"]) ? 'inline-block' : 'none' } }>Email address is invalid</span>
                                                <span className="err_msg" style={ { display: this.state.emailRegex ? 'inline-block' : 'none' } }>Email address is invalid</span>
                                                <span className="err_msg" style={ { display: this.state.userNameExists ? 'inline-block' : 'none' } } >Email already in use. Enter a different email.</span>
                                                <span className="err_msg" style={ { display: this.state.invalidDomain ? 'inline-block' : 'none' } } >{ this.state.isMsgShow ? "Enter a valid business domain email address" : "Email address is invalid" }</span>
                                            </div>
                                            <div className="inp_row clearfix">
                                                <label>Password</label>
                                                <div className="inp_icon_wrap pwd_field_wrap">
                                                    { this.state.pwdstrength === "" ? "" : this.state.pwdstrength === "weak" ? <div class="pwd_strength weak">Weak</div> :
                                                        <div class="pwd_strength strong">Strong</div>
                                                    }
                                                    <input type={ this.state.hidePwd ? "password" : "text" } id="password" ref={ this.passwordInput } name="password" value={ this.state.password } onChange={ this.formChangeHandler } onClick={ (e) => this.inputFocus(e, "password") } onFocus={ (e) => this.inputFocus(e, "password") } className="txt_box" />
                                                    <div className="id-tooltip id-tooltip-topright">
                                                        <p className="id-tooltip-note">Use atleast:</p>
                                                        <ul>
                                                            <li id="upperCaseLi">1 uppercase character</li>
                                                            <li id="lowerCaseLi">1 lowercase character</li>
                                                            <li id="numericLi">1 numerical digit</li>
                                                            <li id="specCharLi">1 special character</li>
                                                            <li id="eightCharLi">Min 8 characters</li>
                                                        </ul>
                                                    </div>
                                                    <span className={ this.state.isPwdShown ? "pwd_field_eyeIcon show_pwd" : "pwd_field_eyeIcon" } data-tip data-for="password" onClick={ this.handleToggle }></span>
                                                </div><ReactTooltip id="password" place="bottom" effect="solid">
                                                    { this.state.isPwdShown ? "Hide" : "Show" }
                                                </ReactTooltip>
                                                <span className="err_msg" id="passwordErr" style={ { display: this.state.passwordEmpty ? 'inline-block' : 'none' } } >Password cannot be blank</span>
                                                <span className="err_msg" style={ { display: (this.state.errors["password"] !== undefined && this.state.errors["password"]) ? 'inline-block' : 'none' } }>Password  should be of minimum 8 characters and must contain atleast 1 uppercase alphabet, 1 lowercase alphabet, 1 numerical digit, and 1 special character </span>
                                                <span className="err_msg" style={ { display: this.state.passwordRegex ? 'inline-block' : 'none' } }>Password is invalid</span>
                                            </div>
                                            <div className="inp_row clearfix">
                                                <div className="inp_col_lhs">
                                                    <label>Country Code</label>
                                                    <div className="custom_select_box coutry_code_wrap">
                                                        <select className="txt_box" name="countryCode" id="countryCode" value={ this.state.countryCode } onChange={ this.formChangeHandler } onFocus={ (e) => this.inputFocus(e, "phone") } onClick={ (e) => this.inputFocus(e, "phone") }>
                                                            <option value="" style={ { display: "none" } } disabled={ true }>Select the country code</option>
                                                            <option value="USA +1">USA +1</option>
                                                            <option value="Afghanistan +93">Afghanistan +93 </option>
                                                            <option value="Albania +355">Albania +355 </option>
                                                            <option value="Algeria +213">Algeria +213 </option>
                                                            <option value="American Samoa +684">American Samoa +684 </option>
                                                            <option value="Andorra +376">Andorra +376 </option>
                                                            <option value="Angola +244">Angola +244 </option>
                                                            <option value="Anguilla +1-264">Anguilla +1-264 </option>
                                                            <option value="Antarctica +672">Antarctica +672 </option>
                                                            <option value="Antigua and Barbuda +1-268">Antigua and Barbuda +1-268 </option>
                                                            <option value="Argentina +54">Argentina +54 </option>
                                                            <option value="Armenia +374">Armenia +374 </option>
                                                            <option value="Aruba +297">Aruba +297 </option>
                                                            <option value="Australia +61">Australia +61 </option>
                                                            <option value="Austria +43">Austria +43 </option>
                                                            <option value="Azerbaijan +994">Azerbaijan +994 </option>
                                                            <option value="Bahamas +1-242">Bahamas +1-242 </option>
                                                            <option value="Bahrain +973">Bahrain +973 </option>
                                                            <option value="Bangladesh +880">Bangladesh +880 </option>
                                                            <option value="Barbados +1-246">Barbados +1-246 </option>
                                                            <option value="Belarus +375">Belarus +375 </option>
                                                            <option value="Belgium +32">Belgium +32 </option>
                                                            <option value="Belize +501">Belize +501 </option>
                                                            <option value="Benin +229">Benin +229 </option>
                                                            <option value="Bermuda +1-441">Bermuda +1-441 </option>
                                                            <option value="Bhutan +975">Bhutan +975 </option>
                                                            <option value="Bolivia +591">Bolivia +591 </option>
                                                            <option value="Bosnia-Herzegovina +387">Bosnia-Herzegovina +387 </option>
                                                            <option value="Botswana +267">Botswana +267 </option>
                                                            <option value="Brazil +55">Brazil +55 </option>
                                                            <option value="Brunei Darussalam +673">Brunei Darussalam +673 </option>
                                                            <option value="Bulgaria +359">Bulgaria +359 </option>
                                                            <option value="Burkina Faso +226">Burkina Faso +226 </option>
                                                            <option value="Burundi +257">Burundi +257 </option>
                                                            <option value="Cambodia +855">Cambodia +855 </option>
                                                            <option value="Cameroon +237">Cameroon +237 </option>
                                                            <option value="Canada +1">Canada +1 </option>
                                                            <option value="Cape Verde +238">Cape Verde +238 </option>
                                                            <option value="Cayman Islands +1-345">Cayman Islands +1-345 </option>
                                                            <option value="Central African Republic +236">Central African Republic +236 </option>
                                                            <option value="Chad +235">Chad +235 </option>
                                                            <option value="Chile +56">Chile +56 </option>
                                                            <option value="China +86">China +86 </option>
                                                            <option value="Christmas Island +61">Christmas Island +61 </option>
                                                            <option value="Cocos (Keeling) Islands +61">Cocos (Keeling) Islands +61 </option>
                                                            <option value="Colombia +57">Colombia +57 </option>
                                                            <option value="Comoros +269">Comoros +269 </option>
                                                            <option value="Congo +242">Congo +242 </option>
                                                            <option value="Congo, Dem. Republic +243">Congo, Dem. Republic +243 </option>
                                                            <option value="Cook Islands +682">Cook Islands +682 </option>
                                                            <option value="Costa Rica +506">Costa Rica +506 </option>
                                                            <option value="Croatia +385">Croatia +385 </option>
                                                            <option value="Cuba +53">Cuba +53 </option>
                                                            <option value="Cyprus +357">Cyprus +357 </option>
                                                            <option value="Czech Rep. +420">Czech Rep. +420 </option>
                                                            <option value="Denmark +45">Denmark +45 </option>
                                                            <option value="Djibouti +253">Djibouti +253 </option>
                                                            <option value="Dominica +1-767">Dominica +1-767 </option>
                                                            <option value="Dominican Republic +809">Dominican Republic +809 </option>
                                                            <option value="Ecuador +593">Ecuador +593 </option>
                                                            <option value="Egypt +20">Egypt +20 </option>
                                                            <option value="El Salvador +503">El Salvador +503 </option>
                                                            <option value="Equatorial Guinea +240">Equatorial Guinea +240 </option>
                                                            <option value="Eritrea +291">Eritrea +291 </option>
                                                            <option value="Estonia +372">Estonia +372 </option>
                                                            <option value="Ethiopia +251">Ethiopia +251 </option>
                                                            <option value="Falkland Islands (Malvinas) +500">Falkland Islands (Malvinas) +500 </option>
                                                            <option value="Faroe Islands +298">Faroe Islands +298 </option>
                                                            <option value="Fiji +679">Fiji +679 </option>
                                                            <option value="Finland +358">Finland +358 </option>
                                                            <option value="France +33">France +33 </option>
                                                            <option value="French Guiana +594">French Guiana +594 </option>
                                                            <option value="Gabon +241">Gabon +241 </option>
                                                            <option value="Gambia +220">Gambia +220 </option>
                                                            <option value="Georgia +995">Georgia +995 </option>
                                                            <option value="Germany +49">Germany +49 </option>
                                                            <option value="Ghana +233">Ghana +233 </option>
                                                            <option value="Gibraltar +350">Gibraltar +350 </option>
                                                            <option value="Great Britain +44">Great Britain +44 </option>
                                                            <option value="Greece +30">Greece +30 </option>
                                                            <option value="Greenland +299">Greenland +299 </option>
                                                            <option value="Grenada +1-473">Grenada +1-473 </option>
                                                            <option value="Guadeloupe (French) +590">Guadeloupe (French) +590 </option>
                                                            <option value="Guam (USA) +1-671">Guam (USA) +1-671 </option>
                                                            <option value="Guatemala +502">Guatemala +502 </option>
                                                            <option value="Guinea +224">Guinea +224 </option>
                                                            <option value="Guinea Bissau +245">Guinea Bissau +245 </option>
                                                            <option value="Guyana +592">Guyana +592 </option>
                                                            <option value="Haiti +509">Haiti +509 </option>
                                                            <option value="Honduras +504">Honduras +504 </option>
                                                            <option value="Hong Kong +852">Hong Kong +852 </option>
                                                            <option value="Hungary +36">Hungary +36 </option>
                                                            <option value="Iceland +354">Iceland +354 </option>
                                                            <option value="India +91">India +91 </option>
                                                            <option value="Indonesia +62">Indonesia +62 </option>
                                                            <option value="Iran +98">Iran +98 </option>
                                                            <option value="Iraq +964">Iraq +964 </option>
                                                            <option value="Ireland +353">Ireland +353 </option>
                                                            <option value="Israel +972">Israel +972 </option>
                                                            <option value="Italy +39">Italy +39 </option>
                                                            <option value="Ivory Coast +225">Ivory Coast +225 </option>
                                                            <option value="Jamaica +1-876">Jamaica +1-876 </option>
                                                            <option value="Japan +81">Japan +81 </option>
                                                            <option value="Jordan +962">Jordan +962 </option>
                                                            <option value="Kazakhstan +7">Kazakhstan +7 </option>
                                                            <option value="Kenya +254">Kenya +254 </option>
                                                            <option value="Kiribati +686">Kiribati +686 </option>
                                                            <option value="Korea-North +850">Korea-North +850 </option>
                                                            <option value="Korea-South +82">Korea-South +82 </option>
                                                            <option value="Kuwait +965">Kuwait +965 </option>
                                                            <option value="Kyrgyzstan +996">Kyrgyzstan +996 </option>
                                                            <option value="Laos +856">Laos +856 </option>
                                                            <option value="Latvia +371">Latvia +371 </option>
                                                            <option value="Lebanon +961">Lebanon +961 </option>
                                                            <option value="Lesotho +266">Lesotho +266 </option>
                                                            <option value="Liberia +231">Liberia +231 </option>
                                                            <option value="Libya +218">Libya +218 </option>
                                                            <option value="Liechtenstein +423">Liechtenstein +423 </option>
                                                            <option value="Lithuania +370">Lithuania +370 </option>
                                                            <option value="Luxembourg +352">Luxembourg +352 </option>
                                                            <option value="Macau +853">Macau +853 </option>
                                                            <option value="Macedonia +389">Macedonia +389 </option>
                                                            <option value="Madagascar +261">Madagascar +261 </option>
                                                            <option value="Malawi +265">Malawi +265 </option>
                                                            <option value="Malaysia +60">Malaysia +60 </option>
                                                            <option value="Maldives +960">Maldives +960 </option>
                                                            <option value="Mali +223">Mali +223 </option>
                                                            <option value="Malta +356">Malta +356 </option>
                                                            <option value="Marshall Islands +692">Marshall Islands +692 </option>
                                                            <option value="Martinique (French) +596">Martinique (French) +596 </option>
                                                            <option value="Mauritania +222">Mauritania +222 </option>
                                                            <option value="Mauritius +230">Mauritius +230 </option>
                                                            <option value="Mayotte +269">Mayotte +269 </option>
                                                            <option value="Mexico +52">Mexico +52 </option>
                                                            <option value="Micronesia +691">Micronesia +691 </option>
                                                            <option value="Moldova +373">Moldova +373 </option>
                                                            <option value="Monaco +377">Monaco +377 </option>
                                                            <option value="Mongolia +976">Mongolia +976 </option>
                                                            <option value="Montenegro +382">Montenegro +382 </option>
                                                            <option value="Montserrat +1-664">Montserrat +1-664 </option>
                                                            <option value="Morocco +212">Morocco +212 </option>
                                                            <option value="Mozambique +258">Mozambique +258 </option>
                                                            <option value="Myanmar +95">Myanmar +95 </option>
                                                            <option value="Namibia +264">Namibia +264 </option>
                                                            <option value="Nauru +674">Nauru +674 </option>
                                                            <option value="Nepal +977">Nepal +977 </option>
                                                            <option value="Netherlands +31">Netherlands +31 </option>
                                                            <option value="Netherlands Antilles +599">Netherlands Antilles +599 </option>
                                                            <option value="New Caledonia (French) +687">New Caledonia (French) +687 </option>
                                                            <option value="New Zealand +64">New Zealand +64 </option>
                                                            <option value="Nicaragua +505">Nicaragua +505 </option>
                                                            <option value="Niger +227">Niger +227 </option>
                                                            <option value="Nigeria +234">Nigeria +234 </option>
                                                            <option value="Niue +683">Niue +683 </option>
                                                            <option value="Norfolk Island +672">Norfolk Island +672 </option>
                                                            <option value="Northern Mariana Islands +670">Northern Mariana Islands +670 </option>
                                                            <option value="Norway +47">Norway +47 </option>
                                                            <option value="Oman +968">Oman +968 </option>
                                                            <option value="Pakistan +92">Pakistan +92 </option>
                                                            <option value="Palau +680">Palau +680 </option>
                                                            <option value="Panama +507">Panama +507 </option>
                                                            <option value="Papua New Guinea +675">Papua New Guinea +675 </option>
                                                            <option value="Paraguay +595">Paraguay +595 </option>
                                                            <option value="Peru +51">Peru +51 </option>
                                                            <option value="Philippines +63">Philippines +63 </option>
                                                            <option value="Poland +48">Poland +48 </option>
                                                            <option value="Polynesia (French) +689">Polynesia (French) +689 </option>
                                                            <option value="Portugal +351">Portugal +351 </option>
                                                            <option value="Puerto Rico +1-787">Puerto Rico +1-787 </option>
                                                            <option value="Qatar +974">Qatar +974 </option>
                                                            <option value="Reunion (French) +262">Reunion (French) +262 </option>
                                                            <option value="Romania +40">Romania +40 </option>
                                                            <option value="Russia +7">Russia +7 </option>
                                                            <option value="Rwanda +250">Rwanda +250 </option>
                                                            <option value="Saint Helena +290">Saint Helena +290 </option>
                                                            <option value="Saint Kitts &amp; Nevis Anguilla +1-869">Saint Kitts &amp; Nevis Anguilla +1-869 </option>
                                                            <option value="Saint Lucia +1-758">Saint Lucia +1-758 </option>
                                                            <option value="Saint Pierre and Miquelon +508">Saint Pierre and Miquelon +508 </option>
                                                            <option value="Saint Vincent &amp; Grenadines +1-784">Saint Vincent &amp; Grenadines +1-784 </option>
                                                            <option value="Samoa +684">Samoa +684 </option>
                                                            <option value="San Marino +378">San Marino +378 </option>
                                                            <option value="Sao Tome and Principe +239">Sao Tome and Principe +239 </option>
                                                            <option value="Saudi Arabia +966">Saudi Arabia +966 </option>
                                                            <option value="Senegal +221">Senegal +221 </option>
                                                            <option value="Serbia +381">Serbia +381 </option>
                                                            <option value="Seychelles +248">Seychelles +248 </option>
                                                            <option value="Sierra Leone +232">Sierra Leone +232 </option>
                                                            <option value="Singapore +65">Singapore +65 </option>
                                                            <option value="Slovakia +421">Slovakia +421 </option>
                                                            <option value="Slovenia +386">Slovenia +386 </option>
                                                            <option value="Solomon Islands +677">Solomon Islands +677 </option>
                                                            <option value="Somalia +252">Somalia +252 </option>
                                                            <option value="South Africa +27">South Africa +27 </option>
                                                            <option value="Spain +34">Spain +34 </option>
                                                            <option value="Sri Lanka +94">Sri Lanka +94 </option>
                                                            <option value="Sudan +249">Sudan +249 </option>
                                                            <option value="Suriname +597">Suriname +597 </option>
                                                            <option value="Swaziland +268">Swaziland +268 </option>
                                                            <option value="Sweden +46">Sweden +46 </option>
                                                            <option value="Switzerland +41">Switzerland +41 </option>
                                                            <option value="Syria +963">Syria +963 </option>
                                                            <option value="Taiwan +886">Taiwan +886 </option>
                                                            <option value="Tajikistan +992">Tajikistan +992 </option>
                                                            <option value="Tanzania +255">Tanzania +255 </option>
                                                            <option value="Thailand +66">Thailand +66 </option>
                                                            <option value="Togo +228">Togo +228 </option>
                                                            <option value="Tokelau +690">Tokelau +690 </option>
                                                            <option value="Tonga +676">Tonga +676 </option>
                                                            <option value="Trinidad and Tobago +1-868">Trinidad and Tobago +1-868 </option>
                                                            <option value="Tunisia +216">Tunisia +216 </option>
                                                            <option value="Turkey +90">Turkey +90 </option>
                                                            <option value="Turkmenistan +993">Turkmenistan +993 </option>
                                                            <option value="Turks and Caicos Islands +1-649">Turks and Caicos Islands +1-649 </option>
                                                            <option value="Tuvalu +688">Tuvalu +688 </option>
                                                            <option value="U.K. +44">U.K. +44 </option>
                                                            <option value="Uganda +256">Uganda +256 </option>
                                                            <option value="Ukraine +380">Ukraine +380 </option>
                                                            <option value="United Arab Emirates +971">United Arab Emirates +971 </option>
                                                            <option value="Uruguay +598">Uruguay +598 </option>
                                                            <option value="Uzbekistan +998">Uzbekistan +998 </option>
                                                            <option value="Vanuatu +678">Vanuatu +678 </option>
                                                            <option value="Vatican +39">Vatican +39 </option>
                                                            <option value="Venezuela +58">Venezuela +58 </option>
                                                            <option value="Vietnam +84">Vietnam +84 </option>
                                                            <option value="Virgin Islands (British) +1-28284">Virgin Islands (British) +1-28484 </option>
                                                            <option value="Virgin Islands (USA) +1-34040">Virgin Islands (USA) +1-34040 </option>
                                                            <option value="Wallis and Futuna Islands +681">Wallis and Futuna Islands +681 </option>
                                                            <option value="Yemen +967">Yemen +967 </option>
                                                            <option value="Zambia +260">Zambia +260 </option>
                                                            <option value="Zimbabwe +263">Zimbabwe +263 </option>
                                                        </select>
                                                    </div>
                                                    <span className="err_msg" style={ { display: this.state.countrycodeempty ? "inline-block" : "none" } }>Country code cannot be blank</span>
                                                </div>
                                                <div className="inp_col_rhs">
                                                    <label>Phone Number</label>
                                                    <div className="phone-field">
                                                        <input type="text" autoComplete="off" maxLength="20" ref={ this.phoneNumberInput } name="phoneNumber" value={ this.state.phone } onFocus={ (e) => this.inputFocus(e, "phone") } onBlur={ (e) => this.inputFocus(e, "lastfield") } onClick={ (e) => this.inputFocus(e, "phone") } onChange={ this.formChangeHandler } className="txt_box" />
                                                        <div className="id-tooltip id-tooltip-topright normal">
                                                            <p className="id-tooltip-note">Use atleast:</p>
                                                            <ul>
                                                                <li id="min_sev">minimum of 7 characters </li>
                                                                <li id="max_twe">maximum of 20 characters</li>
                                                                <li id="no_spe">only characters 0-9 x X - + ()</li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <span className="err_msg" style={ { display: this.state.phoneNumberEmpty ? 'inline-block' : 'none' } } >Phone Number cannot be blank</span>
                                                    <span className="err_msg" style={ { display: this.state.phoneNumberRegex ? 'inline-block' : 'none' } } >Phone number is invalid</span>
                                                </div>
                                                <p className="form_note">Your phone number may help us reach out to you for service-related notifications.</p>

                                            </div>

                                        </div>
                                        <div className="inp_billing_container">
                                            <div className="inp_billing_box">
                                                <div className="inp_row card_detail_field clearfix">
                                                    <label>Card Number, expiry date and CVC
                                                        <span className="svg_wrap" data-tip data-for="cvc">
                                                            <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                                <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="14px">?</text>
                                                            </svg>
                                                        </span>
                                                        <ReactToolTip id="cvc" place="top" multiline={ true } effect="solid">
                                                            For Visa, MasterCard, and Discover cards,<br></br> the CVV is the last 3 digit number located on the back of your card <br></br> on or above your signature line. For an American Express card,<br></br> it is the 4 digits on the FRONT above the end of your card number.
                                                        </ReactToolTip>
                                                    </label>
                                                    <CardSectionSignUp />
                                                    <p className="form_note">An amount of $1.00 will be charged and placed in temporary hold for validating your card. The amount will be refunded post verification. After that, you will be charged only for the services used.</p>
                                                    <div id="card-element" ></div>
                                                    <div id="card-errors" role="alert"></div>
                                                    <span className="err_msg" id="ccDetailsErr" ></span>
                                                </div>
                                                <div className="inp_row clearfix">
                                                    <div className="inp_col_lhs">
                                                        <label>Billing Address</label>
                                                        <input type="text" ref={ this.billingAddressInput } name="billingAddress" id="billingAddress" value={ this.state.signupForm.billingAddress } onChange={ this.formChangeHandler } className="txt_box" onFocus={ (e) => this.inputFocus(e, "billing") } onClick={ (e) => this.inputFocus(e, "billing") } />
                                                        <span className="err_msg" id="billingAddressErr" style={ { display: this.state.billingAddressEmpty ? 'inline-block' : 'none' } } >Billing Address cannot be blank</span>
                                                    </div>
                                                    <div className="inp_col_rhs">
                                                        <label>Zip Code</label>
                                                        <input type="text" ref={ this.zipCodeInput } name="zipCode" id="zipCode" value={ this.state.signupForm.zipCode } onChange={ this.formChangeHandler } className="txt_box" maxLength="20" onFocus={ (e) => this.inputFocus(e, "zipcode") } onClick={ (e) => this.inputFocus(e, "zipcode") } onBlur={ (e) => this.inputFocus(e, "zipcodeblur") } />
                                                        <span className="err_msg" id="zipCodeErr" style={ { display: this.state.zipCodeEmpty ? 'inline-block' : 'none' } } >Zip Code cannot be blank</span>
                                                        <span className="err_msg" style={ { display: this.state.zipCodeRegex ? 'block' : 'none' } }> Zip code can only contain characters A - Z, a - z, 0 - 9, -, _ and blank space </span>
                                                    </div>
                                                </div>
                                                <div className="inp_row clearfix ">
                                                    <div className="pricing_terms">
                                                        <h3>Pricing Terms</h3>
                                                        <ul>
                                                            <li>1. You are enrolling for an automatic renewal service and authorizing a recurring charge to your credit card.</li>
                                                            <li>2. The { this.state.promoDis }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="terms_wrap" id="terms_wrap">
                                                    <input type="checkbox" name="isAgreed" value={ this.state.signupForm.isAgreed } onChange={ this.formChangeHandler } id="compute_terms" />
                                                    <label htmlFor="compute_terms">I agree to the <a href="https://www.idrivecompute.com/terms-and-conditions.htm" target="_blank">IDrive<sup>&reg;</sup> Compute terms</a> and acknowledge that I can receive emails on product updates from IDrive.</label>
                                                    <span className="err_msg" style={ { display: this.state.checkboxstatus ? 'inline-block' : 'none', fontSize: 15 } }>You must Agree the terms of IDrive<sup>&reg;</sup> Compute for account creation</span>
                                                </div>

                                                <div className={ this.state.isAction ? "inp_btn_wrap loginSubmitLoader" : "inp_btn_wrap" }><input type="submit" name="" value={ this.state.isAction ? "" : "Create my account" } className="submit_btn" disabled={ !this.props.stripe } /> </div>
                                            </div>
                                        </div>

                                    </form>
                                    <p class="id-verify" style={ { display: "" } }>For non-business email addresses, there may be an ID verification process.</p>
                                    <p class="id-verify" style={ { display: "none" } }>Available for customers with a valid business domain email address only.</p>
                                    <div className={ this.state.isSwitch ? "switchpage-pricing" : "promopage-pricing" }>
                                        <p>Once you signup for IDrive Compute here for the special discount, you will be able to create VM instances for any location at the discount signed up for.</p>
                                        <div class="plan_box">
                                            <div class="cost_details">
                                                <div class="plan_storage"> <span>1.0 TB NVMe</span> </div>
                                                <div class="actual_cost">
                                                    <p> <span class="strike_thru">$2220</span>/year </p>
                                                    <p class="cost_option">${ 2220 - (2220 * (this.state.promoDis / 100)) }<span class="cost-sub">/first year</span></p>
                                                </div>
                                            </div>
                                            <div class="plan_details">
                                                <div class="plan-config"> <span><b>Intel Xeon E-2236</b> Processor <b>6 </b> cores / <b>12</b> threads</span> </div>
                                                <ul class="detail_info">
                                                    <li>
                                                        <div class="col1">Memory</div>
                                                        <div class="col2">32 GB</div>
                                                    </li>
                                                    <li style={ { display: 'none' } }>
                                                        <div class="col1">Bandwidth</div>
                                                        <div class="col2">unlimited</div>
                                                    </li>
                                                    <li>
                                                        <div class="col1">Ethernet</div>
                                                        <div class="col2">10 Gbps</div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>

                </main>
                <div className={ this.state.isPhoneVerifyPopup ? "main_popup accModule_mobileOtp_popup active" : "main_popup accModule_mobileOtp_popup" }>
                    <div className="main_popup_bg_shadow"></div>
                    <div className="main_popup__inner">
                        <div className="popup_wrap">
                            <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.closePhoneVerifyPopup() }></span>
                            <div className="popup_header">
                                <div className="sub_title">Verify Phone Number</div>
                            </div>
                            <div className="popup_body">
                                <div className="common_txtBox_row">
                                    <p className="resend_msg" id="resend_msg" style={ { display: "none" } }>Verification OTP has been resent.</p>
                                    <p className="resend_msg" id="verify_otp_msg" style={ { display: "none" } }>Error occured. Enter a valid OTP.</p>
                                    <p className="resend_msg" style={ { display: "none" } }>Verification code has been resent.</p>
                                    <p className="resend_msg" style={ { display: this.state.otpVerification ? 'inline-block' : 'none' } } >OTP verification is processing...</p>
                                    <p>A one time password has been sent to <b>{ this.state.signupForm.countryCode }{ this.state.signupForm.phoneNumber }</b></p>
                                    <label>Enter the OTP to verify your phone number</label>
                                    <input type="password" ref={ this.otpInput } name="otp" id="otp" value={ this.state.otp } className="txtBox" maxLength="6" onChange={ this.handleOtp } onKeyUp={ this.handleOTPKeyUp } />
                                    <span className="err_msg" style={ { display: this.state.otpempty ? 'inline-block' : 'none' } } >Verification code cannot be blank</span>
                                    <span className="err_msg" style={ { display: this.state.otpErr ? 'inline-block' : 'none' } } >Enter a valid OTP</span>

                                </div>
                                <p className="otp-timer" id="otp_timer">Your verification code will expire in <b>5</b> Minutes</p>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button className={ this.state.showVerifyLoader ? "btn blue verify_btn submitLoader" : "btn blue verify_btn" } id="verify_btn" disabled={ this.state.otp.length < 6 } onClick={ this.verifyOtp } >Verify</button>
                                        <button className="btn blue resend_btn " id="resend_btn" onClick={ () => this.sendOtp("resend") }>Resend OTP</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clear"></div>
                <footer>
                    <div className="wrapper">
                        <p className="copy_cont">© 2022 IDrive Inc.</p>
                    </div>
                </footer>
                <CommonMessage message={ this.state.message } handler={ () => this.setState({ message: '' }) }
                    msgType={ this.state.msgType } />
                <ReCAPTCHA
                    sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                    onChange={ (e) => this.onRecaptchaChange(e) }
                    ref={ this.recaptchaRef }
                    size="invisible"
                />
            </body>
        );
    }
}

export default function InjectedCheckoutFormSignup() {

    return (
        <ElementsConsumer>
            { ({ stripe, elements }) => (
                <BareMetalCheckout stripe={ stripe } elements={ elements } />
            ) }
        </ElementsConsumer>
    );
}

function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1500));
}